var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showAsHeadline)?_c('BaseHeadline',_vm._b({},'BaseHeadline',_vm.headlineProps,false),[_vm._t("default")],2):_c('span',{staticClass:"mb-4 font-bold"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }